<template>
  <div>
    <section class="section">
      <div class="container" style="padding-top:50px;">
        <div class="columns is-multiline">
          <div class="column is-12">
            <div class="content">
              <h1>Ihr Auftritt auf urlaubimwaldviertel.at</h1>

              <p>Mit unserer innovativen Web-Plattform urlaubimwaldviertel.at möchten wir auch Ihnen die Gelegenheit geben, Ihr Unternehmen und Ihre Angebote zu präsentieren. Dafür haben wir attraktive Packages geschnürt, die sicherstellen, dass Ihr Angebot einem breiten Publikum zugänglich gemacht wird. Unabhängig von Branche und Betriebsgröße, Sie können sicher sein, dass wir die richtigen Lösungen für die Präsentation Ihres Unternehmens auf urlaubimwaldviertel.at haben. Schreiben Sie uns, wir werden uns umgehend mit Ihnen in Verbindung setzen!</p>

              <p class="field">
                <a
                  class="button is-link is-fullwidth"
                  href="https://www.messenger.com/t/307909466390506/"
                  target="_blank"
                >
                  <span class="icon">
                    <i class="fa fa-comments"></i>
                  </span>
                  <span>Facebook Messenger</span>
                </a>
              </p>

              <p class="field">
                <a class="button is-fullwidth" :href="'mailto:' + contact()">
                  <span class="icon">
                    <i class="fa fa-envelope"></i>
                  </span>
                  <span>{{ contact() }}</span>
                </a>
              </p>

              <p class="field">
                <a class="button is-fullwidth" href="tel:+436642628269">
                  <span class="icon">
                    <i class="fa fa-phone"></i>
                  </span>
                  <span>+43 (0) 664 262 82 69</span>
                </a>
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
export default {
  data() {
    return {}
  },
  metaInfo: {
    title: 'Unser Angebot an Sie',
    meta: [
      {
        vmid: 'description',
        name: 'description',
        content:
          'Mit einer Veranstaltung, der eigenen Unterkunft oder dem eigenen Restaurant auf www.urlaubimwaldviertel.at vertreten sein? Kein Problem, setzten Sie sich mit uns in Verbindung, wir freuen uns von Ihnen zu hören!'
      },
      { vmid: 'twitter:card', name: 'twitter:card', value: 'summary' },
      {
        vmid: 'og:title',
        property: 'og:title',
        content: 'Unser Angebot an Sie'
      },
      { vmid: 'og:type', property: 'og:type', content: 'article' },
      {
        vmid: 'og:url',
        property: 'og:url',
        content: 'https://www.urlaubimwaldviertel.at/unser-angebot/'
      },
      {
        vmid: 'og:image',
        property: 'og:image',
        content:
          'https://assets.urlaubimwaldviertel.at/images/3892-2018-01-wwwurlaubimwaldviertelat.png'
      },
      { vmid: 'og:image:width', property: 'og:image:width', content: 1200 },
      { vmid: 'og:image:height', property: 'og:image:height', content: 630 },
      {
        vmid: 'og:description',
        property: 'og:description',
        content:
          'Mit einer Veranstaltung, der eigenen Unterkunft oder dem eigenen Restaurant auf www.urlaubimwaldviertel.at vertreten sein? Kein Problem, setzten Sie sich mit uns in Verbindung, wir freuen uns von Ihnen zu hören!'
      },
      { vmid: 'fb:app_id', property: 'fb:app_id', content: '1649771028438873' }
    ]
  },
  methods: {
    contact() {
      const eins = 'info'
      const zwei = '@'
      const drei = 'urlaubimwaldviertel'
      const vier = 'at'
      return eins + zwei + drei + '.' + vier
    }
  }
}
</script>

<style>
</style>
